<template>
    <select v-model="input" class="form-control custom-select shadow-sm">
        <option :value="null" disabled selected>Select an option</option>
        <option v-for="option in data" :value="option.id" v-bind:key="option.value">{{ option.name }}</option>
    </select>
</template>

<script>
	export default {
		data() {
			return {
				input: this.citySelected ? this.citySelected : null,
				originalData: null,
				data: null
			};
		},
		created() {
			this.originalData = this.cities;

			this.data = this.filterCities(this.countrySelected);
		},
		watch: {
			input: function(value) {
				this.$emit("update-city", value);
			},
			countrySelected: function(country) {
				this.input = null;

				this.data = this.filterCities(country);
			}
		},
		methods: {
			filterCities(country) {
				return _.sortBy(
					_.filter(this.originalData, city => city.country === country),
					[
						city => {
							return city.name;
						}
					]
				);
			}
		},
		props: ["cities", "countrySelected", "citySelected"]
	};
</script>
